"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ontology = void 0;
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const ForwardReasoning_1 = require("lincd/lib/utils/ForwardReasoning");
const Property_1 = require("lincd-rdf/lib/shapes/Property");
const rdfs_1 = require("lincd-rdfs/lib/ontologies/rdfs");
const Class_1 = require("lincd-rdfs/lib/shapes/Class");
const owl_1 = require("../ontologies/owl");
const package_1 = require("../package");
const shacl_1 = require("lincd-shacl/lib/ontologies/shacl");
const NodeSet_1 = require("lincd/lib/collections/NodeSet");
const Prefix_1 = require("lincd/lib/utils/Prefix");
let Ontology = class Ontology extends Shape_1.Shape {
    get classes() {
        return Class_1.Class.getSetOf(this.getEntities().filter((entity) => {
            return ForwardReasoning_1.ForwardReasoning.hasType(entity, Class_1.Class.targetClass);
            // return entity.getAll(rdf.type).some((type) => {
            //   return type.has(rdfs.subClassOf, Class.targetClass) || type.getAll(rdf.type).some(type => type.has(rdfs.subClassOf, Class.targetClass))
            // });
        }));
    }
    get properties() {
        return Property_1.Property.getSetOf(this.getEntities().filter((entity) => {
            return ForwardReasoning_1.ForwardReasoning.hasType(entity, Property_1.Property.targetClass);
        }));
    }
    /**
     * Add class or property to this ontology
     * (will set the value of rdfs.isDefinedBy to this ontology)
     * @param node
     */
    addEntity(node) {
        node.set(rdfs_1.rdfs.isDefinedBy, this.namedNode);
    }
    getEntities(allowLookupByURIAsFallback = true) {
        let entities = this.getAllInverse(rdfs_1.rdfs.isDefinedBy);
        if (entities.size == 0 && allowLookupByURIAsFallback) {
            //SOME ontologies, like schema.org, do not use rdfs:isDefinedBy
            //so either we manually fix all the RDF for them,
            //or we do this... at runtime, we look up all the entities
            //@TODO if the data is not loaded , this method could potentially be resource intensive
            // without any results.. so how can we avoid that and check if things should be loaded?
            //find back entities based on the URL of the ontology
            let ontologyUri = this.namedNode.uri;
            entities = new NodeSet_1.NodeSet(models_1.NamedNode.getAllNamedNodes().filter(node => {
                return node.uri.startsWith(ontologyUri);
            }).values());
        }
        return entities;
    }
    get declare() {
        return this.getOne(shacl_1.shacl.declare);
    }
    set declare(value) {
        this.overwrite(shacl_1.shacl.declare, value);
    }
    // get defaultPrefix(): NamedNode {
    // 	return this.getOne(graphql, )  // Think about exporting graphql ontology
    // }
    get prefix() {
        if (this.hasProperty(shacl_1.shacl.PrefixDeclaration)) {
            this.getOne(shacl_1.shacl.PrefixDeclaration).getValue(shacl_1.shacl.prefix);
        }
        let prefix = Prefix_1.Prefix.getPrefix(this.namedNode.uri);
        return prefix || undefined;
    }
    set prefix(value) {
        //TODO: check shacl.PrefixDeclaration, we can create one if it doesnt exist
        if (this.hasProperty(shacl_1.shacl.PrefixDeclaration)) {
            this.getOne(shacl_1.shacl.PrefixDeclaration).overwrite(shacl_1.shacl.prefix, new models_1.Literal(value));
        }
    }
};
Ontology.targetClass = owl_1.owl.Ontology;
Ontology = __decorate([
    package_1.linkedShape
], Ontology);
exports.Ontology = Ontology;
//# sourceMappingURL=Ontology.js.map